import { useState } from "react";
import { Menu, X } from "lucide-react";
import Logo from "./Logo";
import { scrollToId } from "@/lib/api";

const LINKS = [
  ["The Problem", "problem"],
  ["Process", "process"],
  ["Platforms", "platforms"],
  ["Packages", "packages"],
  ["About", "about"],
  ["Webinar", "webinar"],
];

export default function Nav() {
  const [open, setOpen] = useState(false);
  const go = (id) => { setOpen(false); scrollToId(id); };
  return (
    <header className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-white/90 border-b border-gold/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between">
        <Logo />
        <nav className="hidden lg:flex items-center gap-7" data-testid="nav-links">
          {LINKS.map(([label, id]) => (
            <button key={id} data-testid={`nav-${id}-link`} onClick={() => go(id)}
              className="text-[11px] tracking-[0.22em] uppercase text-slate-300 hover:text-gold transition-colors">
              {label}
            </button>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <button data-testid="nav-book-audit-button" onClick={() => go("audit")}
            className="hidden sm:inline-flex items-center rounded-full bg-gold px-5 py-2.5 text-[11px] font-bold tracking-[0.18em] uppercase text-navy transition-all hover:bg-gold-hover hover:shadow-[0_0_25px_rgba(212,175,55,0.35)] hover:scale-[1.03]">
            Book Your Audit
          </button>
          <button data-testid="nav-mobile-menu-button" onClick={() => setOpen(!open)}
            className="lg:hidden text-gold p-2" aria-label="Toggle menu">
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>
      {open && (
        <div className="lg:hidden border-t border-gold/20 bg-white/95 backdrop-blur-xl px-6 py-4 space-y-3" data-testid="nav-mobile-menu">
          {LINKS.map(([label, id]) => (
            <button key={id} data-testid={`nav-mobile-${id}-link`} onClick={() => go(id)}
              className="block w-full text-left text-xs tracking-[0.22em] uppercase text-slate-300 hover:text-gold py-1.5">
              {label}
            </button>
          ))}
          <button data-testid="nav-mobile-book-audit-button" onClick={() => go("audit")}
            className="mt-2 w-full rounded-full bg-gold px-5 py-3 text-[11px] font-bold tracking-[0.18em] uppercase text-navy">
            Book Your Audit
          </button>
        </div>
      )}
    </header>
  );
}
